module.exports = __webpack_public_path__ + "img/icons B_28.e85ac34a.svg";